import { render, staticRenderFns } from "./GlobalMiniPlayer.vue?vue&type=template&id=1a3a3a37&scoped=true"
import script from "./GlobalMiniPlayer.vue?vue&type=script&lang=js"
export * from "./GlobalMiniPlayer.vue?vue&type=script&lang=js"
import style0 from "./GlobalMiniPlayer.vue?vue&type=style&index=0&id=1a3a3a37&prod&lang=css"
import style1 from "./GlobalMiniPlayer.vue?vue&type=style&index=1&id=1a3a3a37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3a3a37",
  null
  
)

export default component.exports